import React, { ComponentPropsWithRef, forwardRef } from "react";
import { IconBaseProps } from "react-icons";

type TSelectButtonProps = ComponentPropsWithRef<"button"> & {
  value?: string;
  placeholder?: string;
  label?: string;
  Icon?: React.ReactElement<IconBaseProps>;
  iconProps?: IconBaseProps;
  disabled?: boolean;
};

const SelectButton = forwardRef<HTMLButtonElement, TSelectButtonProps>(
  (
    {
      className = "",
      value,
      placeholder,
      label,
      Icon,
      disabled,
      iconProps,
      ...props
    },
    ref
  ) => {
    return (
      <div className="flex-col gap-4">
        {label && (
          <label
            className={`m-fs-c-base m-0 fw-400 ${
              disabled ? "text-white-300 cursor-not-allowed" : "text-black-900"
            }`}
          >
            {label}
          </label>
        )}
        <button
          tabIndex={0}
          ref={ref}
          className={`m-fs-c-base taptap-focus-ring border-white br-4 min-h-38 px-1 py-10 flex ai-center gap-4 w-100 text-left text-black-900 ${className}`}
          {...props}
        >
          {Icon &&
            React.cloneElement(Icon, {
              className: `text-primary-400 ${iconProps?.className || ""}`,
            })}
          <span style={{ color: value ? `var(--clr-black-900)`: `#808080`}} className="m-fs-c-base fw-400">
            {value || placeholder}
          </span>
        </button>
      </div>
    );
  }
);

export default React.memo(SelectButton);